module.exports = __webpack_public_path__ + "static/media/wave.8c056206.svg";